var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.875C9.12577 12.3773 9.60519 12.793 10.1557 13.0938C10.7063 13.3946 11.3151 13.5734 11.9408 13.6183C12.5666 13.6631 13.1946 13.5728 13.7824 13.3535C14.3702 13.1343 14.904 12.7912 15.3475 12.3475L17.9725 9.72247C18.7694 8.89734 19.2104 7.7922 19.2004 6.64509C19.1905 5.49798 18.7304 4.40067 17.9192 3.58951C17.108 2.77835 16.0107 2.31824 14.8636 2.30827C13.7165 2.2983 12.6114 2.73928 11.7863 3.53622L10.2812 5.03247",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2494 10.1251C11.8737 9.62271 11.3943 9.20704 10.8437 8.90625C10.2932 8.60546 9.68437 8.4266 9.05862 8.38178C8.43287 8.33697 7.8048 8.42725 7.21701 8.64652C6.62923 8.86578 6.09547 9.20889 5.65194 9.65257L3.02694 12.2776C2.23 13.1027 1.78903 14.2078 1.79899 15.355C1.80896 16.5021 2.26908 17.5994 3.08024 18.4105C3.8914 19.2217 4.9887 19.6818 6.13581 19.6918C7.28292 19.7017 8.38806 19.2608 9.21319 18.4638L10.7094 16.9676",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9f2eb25c8dfaffdcf8ae06c79021dcab.svg";
export { ForwardRef as ReactComponent };